import showScrollProgress from '../utils/showScrollProgress';
import {breakpoints} from '../constants/breakpoints';
import STATE from '../constants/state';

const selectors = {
  section: '.js-testimonials-section',
  bg: '.js-testimonials-bg',
  blank: '.js-testimonials-blank-bg',
};

const handleTestimonialsAnimation = () => {
  const section = document.querySelector(selectors.section);
  if (!section) return;

  const bg = section.querySelector(selectors.bg);
  if (!bg) return;

  const blank = section.querySelector(selectors.blank);
  const rootBottom = 0.4; // it is responsible for progress margin value

  let widthDifference;
  let heightDifference;
  let borderMultipler;
  let multiplier = 0;
  let myProgress = 0;

  const setProperties = () => {
    section.style.setProperty('--height-offset', heightDifference - heightDifference * multiplier);
    section.style.setProperty('--width-offset', widthDifference - widthDifference * multiplier);
    section.style.setProperty('--border-radius', myProgress * borderMultipler);
  };

  const resizer = () => {
    widthDifference = window.innerWidth - blank.clientWidth;
    heightDifference = section.scrollHeight - blank.clientHeight;
    borderMultipler = breakpoints.tablet > window.innerWidth ? 25 : 75;

    setProperties();
  };

  // Init
  resizer();
  setProperties();
  window.addEventListener('resize', resizer);

  showScrollProgress(section, ({progress}) => {
    myProgress = progress;

    if (myProgress > rootBottom) {
      section.classList.add(STATE.inView);
    } else {
      multiplier = myProgress * (1 / rootBottom);
      setProperties();

      section.classList.remove(STATE.inView);
      bg.classList.add(STATE.active);
    }
  });
};

export default handleTestimonialsAnimation;
